<ion-item (click)="open()" button detail="true">
  <ion-input style="cursor: pointer" readonly="true" label-placement="floating" label="Táxon"
             [value]="taxon?.name"/>

</ion-item>

<ion-modal [isOpen]="isOpen">
  <ng-template>
    <ion-header>
      <ion-toolbar color="success">
        <ion-title>Taxons ({{grupos}})</ion-title>
        <ion-buttons slot="start">
          <ion-button (click)="voltar()">
            <ion-icon name="arrow-back-outline"/>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-toolbar>
        <ion-searchbar  (ionInput)="handleInput($event)"></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <ion-content color="light" class="ion-padding">
      <ion-list id="modal-list" >
        <ion-item (click)="selecionar(item)" *ngFor="let item of results">
          <div>
            <ion-label class="ion-text-wrap">
              {{item.name}}
            </ion-label>
            <ion-note  class="ion-text-wrap" color="medium">
              {{item.nomesComuns}}
            </ion-note>
          </div>
        </ion-item>
      </ion-list>
    </ion-content>

  </ng-template>
</ion-modal>
